<style lang="scss">
  @import '../../../sass/variables';

  .category-tags {
    background-color: $white;
    padding: 0px;
    border-radius: 5px;

    .multiselect__tags {
      height: unset;
      min-height: 0px;
      padding: 0;
      border: none;

      .multiselect__tags-wrap {
        font-size: 0.75rem;
        font-weight: 500;
        padding: 0.6875rem 1.2rem 0.25rem;
        display: inherit;

        .multiselect__tag {
          color: $white;
          background: $gray-dark;
          line-height: 30px;
          padding: 0 1.5625rem 0 0.75rem;
          margin-right: 7px;
          margin-bottom: 7px;
          border-radius: 30px;
          vertical-align: middle;

          span {
            margin-right: 0.25rem;
          }

          .multiselect__tag-icon {
            width: 25px;
            line-height: 30px;
            margin: 0;

            &:after {
              color: $white;
              font-size: 0.75rem;
              font-weight: 500;
              margin-left: -5px;
              content: 'x';
            }

            &:hover {
              background: $green;
              border-radius: 0 30px 30px 0;
            }
          }
        }
      }

      .multiselect__input {
        color: $gray-dark;
        font-size: 0.75rem;
        line-height: 30px;
        padding: 0.6875rem 1.2rem;
        margin: 0;
      }

      .multiselect__placeholder {
        color: $gray-light;
        font-size: 0.75rem;
        line-height: 30px;
        padding: 0.6875rem 1.2rem;
        margin: 0;
      }

      .multiselect__spinner {
        background: transparent;
        height: 100%;
      }
    }

    .multiselect__content-wrapper {
      border: 0;

      .multiselect__content {
        display: block !important;

        .multiselect__option {
          height: 52px;
          line-height: 30px;
          padding: 0.6875rem 1.2rem;
        }

        .multiselect__option:after {
          background: $green;
          font-weight: 500;
          line-height: 52px;
        }
      }

      &:before {
        display: none;
      }
    }
  }
</style>

<template>
  <span v-if="loading"><i class="m-l-5 fa fa-circle-o-notch fa-spin" /></span>
  <div
    class="category-tags"
    v-else
  >
    <Multiselect
      label="name"
      track-by="id"
      v-model="categories"
      :placeholder="__('Categoria')"
      tag-placeholder="Criar categoria"
      :options="options"
      :multiple="true"
      :taggable="true"
      :show-labels="false"
      :hide-selected="true"
      :show-no-options="false"
      :show-no-results="false"
      @tag="create"
      @select="add"
      @remove="remove"
    /><span
      slot="caret"
      slot-scope="{ toggle }"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },

    model: {
      type: Number,
    },

    type: {
      type: String,
    },

    hide: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      loading: true,
      options: [],
      categories: this.value,
    };
  },

  created () {
    this.getOptions();
  },

  methods: {
    getOptions () {
      this.$http.get(`/category/${this.type}`)
        .then(({ data }) => {
          this.options = data;
        })
        .finally(() => this.loading = false);
    },

    toggle (id, remove = false) {
      const category = {
        remove,
        type: this.type,
        model: this.model,
      };

      this.$http.put(`/category/${id}`, category)
        .then(({ data }) => {
          category.category = data.category;

          Bus.$emit(`category-${this.type}`, category);
        });
    },

    create (name) {
      this.$http.post('/category', { name })
        .then(({ data }) => {
          this.categories.push(data);

          this.toggle(data.id);
        })
        .catch(() => Alert.error(this.__('Não foi possível criar esta categoria.')));
    },

    add (category) {
      this.toggle(category.id);
    },

    remove (category) {
      this.options = this.options.filter((item) => item.id != category.id);
      // ???? deletar um item da lista de opções, por que. Investigar mais afundo??
      // Remove para o caso em que a categoria seja removida no banco, não constar na lista do multiselect, o que causaria erro de not found no servidor.

      this.toggle(category.id, true);
    },
  },
};
</script>
